@file:OptIn(kotlin.uuid.ExperimentalUuidApi::class)

package com.yogaaicoach.pages.workout.test

import com.yogaaicoach.common.core.extensions.format
import com.yogaaicoach.common.ui.components.*
import com.yogaaicoach.scope
import com.yogaaicoach.user.AppViewModel
import kotlinx.coroutines.launch
import react.FC
import react.Props
import react.dom.html.ReactHTML.audio
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.input
import react.dom.html.ReactHTML.label
import react.dom.html.ReactHTML.span
import react.dom.html.ReactHTML.video
import react.useEffectOnce
import react.useState
import web.cssom.ClassName
import web.dom.ElementId
import web.window.window
import kotlin.time.Duration.Companion.seconds

internal external interface TestExercisePageProps : Props {
    var viewModel: TestExerciseJsViewModel
    var appViewModel: AppViewModel
    var onNavigateToDashboard: () -> Unit
    var onNavigateToPayment: () -> Unit
    var onNavigateToContactUs: () -> Unit
}

internal val TestExercisePage = FC<TestExercisePageProps> { props ->
    val vm = props.viewModel

    var countdownSeconds by useState(0)
    var isPaused by useState(false)
    var videoUrl by useState<String?>(null)
    var audioUrl by useState<String?>(null)
    var exerciseGuid by useState("")
    var durationSec by useState("30")
    var repetitions by useState("1")
    var useOtherSide by useState(false)

    useEffectOnce {
        scope.launch { vm.countdownSeconds.collect { countdownSeconds = it } }
        scope.launch { vm.isPaused.collect { isPaused = it } }
        scope.launch { vm.videoUrl.collect { videoUrl = it } }
        scope.launch { vm.audioUrl.collect { audioUrl = it } }
        scope.launch { vm.useOtherSideAudio.collect { useOtherSide = it } }
    }

    TopBar {
        title = "Test Exercise"
        onSignOut = { props.appViewModel.signOut() }
        onNavigateToDashboard = props.onNavigateToDashboard
        onNavigateToPayment = props.onNavigateToPayment
        onNavigateToContactUs = props.onNavigateToContactUs
    }

    div {
        className = ClassName("test-exercise-page")

        div {
            className = ClassName("test-exercise-form")

            div {
                className = ClassName("test-exercise-field")
                label {
                    htmlFor = ElementId("test-guid-input")
                    className = ClassName("test-exercise-label")
                    +"Exercise GUID"
                }
                input {
                    id = ElementId("test-guid-input")
                    className = ClassName("test-exercise-input")
                    value = exerciseGuid
                    placeholder = "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
                    onChange = { exerciseGuid = it.target.value }
                }
            }

            div {
                className = ClassName("test-exercise-row")

                div {
                    className = ClassName("test-exercise-field")
                    label {
                        htmlFor = ElementId("test-duration-input")
                        className = ClassName("test-exercise-label")
                        +"Duration (sec)"
                    }
                    input {
                        id = ElementId("test-duration-input")
                        className = ClassName("test-exercise-input")
                        value = durationSec
                        onChange = { durationSec = it.target.value }
                    }
                }

                div {
                    className = ClassName("test-exercise-field")
                    label {
                        htmlFor = ElementId("test-reps-input")
                        className = ClassName("test-exercise-label")
                        +"Repetitions"
                    }
                    input {
                        id = ElementId("test-reps-input")
                        className = ClassName("test-exercise-input")
                        value = repetitions
                        onChange = { repetitions = it.target.value }
                    }
                }
            }

            button {
                className = ClassName(
                    if (useOtherSide) "test-exercise-toggle-btn test-exercise-toggle-btn-on"
                    else "test-exercise-toggle-btn"
                )
                onClick = { vm.toggleUseOtherSideAudio() }
                span {
                    className = ClassName("test-exercise-toggle-indicator")
                    +if (useOtherSide) "✓" else ""
                }
                +"Other side audio"
            }

            button {
                className = ClassName("primary-button")
                disabled = exerciseGuid.isBlank()
                onClick = {
                    val dur = durationSec.toIntOrNull() ?: 0
                    val reps = repetitions.toIntOrNull() ?: 1
                    vm.onStartWorkout(
                        exerciseGuidStr = exerciseGuid,
                        durationInSeconds = dur,
                        repetitions = reps,
                        isPortraitView = window.innerWidth < 600,
                    )
                }
                +"Start"
            }
        }

        videoUrl?.let { url ->
            div {
                className = ClassName("test-exercise-video-container")
                video {
                    id = ElementId("workout-video")
                    src = url
                    className = ClassName("test-exercise-video")
                    autoPlay = true
                    loop = true
                    playsInline = true
                    onLoadedMetadata = { vm.onVideoReady() }
                }
            }
        }

        audioUrl?.let { url ->
            audio {
                id = ElementId("workout-audio")
                src = url
                autoPlay = true
                onLoadedMetadata = { vm.onAudioReady() }
            }
        }

        if (videoUrl != null || countdownSeconds > 0) {
            div {
                className = ClassName("test-exercise-playback")

                span {
                    className = ClassName("test-exercise-timer")
                    +countdownSeconds.seconds.format()
                }

                button {
                    className = ClassName("workout-play-pause-btn")
                    onClick = { vm.toggleIsPaused() }
                    if (isPaused) PlayCircleIcon {} else PauseCircleIcon {}
                }
            }
        }
    }
}
